module.exports = __webpack_public_path__ + "static/qiqi-35b4a7cdc9ed29419032f4b5389c82ca.png";